import { normalizeBoolean } from '@change-corgi/config/fcm/normalizers';

import { createFcmConfig } from '../shared/factory';

export const FCM_HIDE_SIGNEES = createFcmConfig('hide_signees', {
	normalizer: normalizeBoolean,
	defaultValue: false,
});
